<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m12 18.5-4.8 2.9-.7.1q-.4 0-.6-.2l-.4-.5-.1-.7 1.3-5.5-4.3-3.7A1 1 0 0 1 2 9.6q0-.3.3-.5l.7-.3 5.6-.5L11 3.2q.2-.5.5-.6l.6-.2.6.2q.3.1.5.6l2.2 5.1 5.6.5q.4 0 .7.3a1 1 0 0 1 .4 1.2q0 .3-.4.6l-4.3 3.7 1.3 5.5v.7l-.5.5-.6.2-.7-.1z"
    />
  </svg>
</template>
